<template>
    <section id="cart-recap">
        <EligibilityResult
            v-if="showEligibilityResult && cartRecapData.eligibilityResult"
            :eligibility-result="cartRecapData.eligibilityResult"
        />
        <div class="container-fluid">
            <div class="row px-1">
                <div class="col-12 px-0">
                    <h3 class="mb-md-2 mb-1" v-html="cartRecapData.titleHtml" />
                </div>
                <div class="col-12 px-1 px-lg-0 mb-2 mb-md-3">
                    <div class="row px-0">
                        <!--/* Tuiles à gauche du total en desktop */-->
                        <div class="col-12 col-lg-8 px-0 px-lg-1">
                            <div class="row h-100 px-0">
                                <!--/* MOBILE TILE */-->
                                <section class="order-1 col-12 col-lg-6 px-1 pb-1 pb-lg-0">
                                    <div class="container mw-100 h-100 border-gray recap-mobile-tile px-0">
                                        <div class="row p-1">
                                            <div class="col-6">
                                                <p><strong>{{ mobileOffer.name }}</strong></p>
                                            </div>
                                            <div class="col-6 text-end">
                                                <ob1-prix
                                                    :custom="'recap-ob1-price h3 text-dark'"
                                                    :duration="mobileOffer.price.duration"
                                                    :initial-price="mobileOffer.price.initialPrice"
                                                    :is-mini="true"
                                                    :price="mobileOffer.price.price"
                                                    :price-details="mobileOffer.price.priceDetails"
                                                    :show-by-month="mobileOffer.price.showByMonth"
                                                    :show-end-of-promotion-price="mobileOffer.price.showEndOfPromotionPrice"
                                                    :show-from="mobileOffer.price.showFrom"
                                                    :show-promo-duration="mobileOffer.price.showPromoDuration"
                                                />
                                            </div>
                                        </div>

                                        <!--  Bloqué ou non -->
                                        <div v-if="offerHasVariation" class="row p-1">
                                            <div class="col-6">
                                                <p>
                                                    <strong v-text="blockedMobileOfferTitle" />
                                                </p>
                                            </div>
                                            <div class="ob1-switch col-6">
                                                <input
                                                    id="mobileOfferBlocked"
                                                    class="checkbox visually-hidden"
                                                    name="isMobileOfferBlocked"
                                                    type="checkbox"
                                                    :checked="mobileOffer.blocked"
                                                    @change="onMobileOfferToggleChange($event)"
                                                >
                                                <label
                                                    for="mobileOfferBlocked"
                                                    class="toggle toggle-rounded labels"
                                                    style="float: right;"
                                                    :data-oevent-category="blockedMobileOfferToggleTms.category"
                                                    :data-oevent-label="mobileOffer.blocked ? 'non' : 'oui'"
                                                    :data-oevent-action="blockedMobileOfferToggleTms.action"
                                                >
                                                    <span class="on">Oui</span>
                                                    <span class="off">Non</span>
                                                </label>
                                            </div>
                                            <div class="col-12">
                                                <a
                                                    href="#"
                                                    class="ob1-link-arrow pt-0"
                                                    data-bs-toggle="modal"
                                                    :data-bs-target="'#modal-more-information'"
                                                    :data-oevent-category="blockedMobileOfferPopinTms.category"
                                                    :data-oevent-label="blockedMobileOfferPopinTms.label"
                                                    :data-oevent-action="blockedMobileOfferPopinTms.action"
                                                    v-html="aboutBlockedMobileOfferPopin.linkLabel"
                                                />
                                            </div>
                                            <!--/* POPIN */-->
                                            <div
                                                :id="'modal-more-information'"
                                                class="modal fade"
                                                tabindex="-1"
                                                role="dialog"
                                                aria-labelledby="modalTitle"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog" role="document">
                                                    <div class="modal-content">
                                                        <div class="modal-header">
                                                            <button
                                                                type="button"
                                                                class="btn-close d-none d-md-block"
                                                                data-bs-dismiss="modal"
                                                                aria-label="Fermer"
                                                            >
                                                                <span aria-hidden="true" class="icon icon-delete" />
                                                            </button>
                                                            <button
                                                                type="button"
                                                                class="btn-close d-md-none ob1-link-arrow ob1-link-small back"
                                                                data-bs-dismiss="modal"
                                                            >
                                                                Retour
                                                            </button>
                                                        </div>
                                                        <div class="modal-body">
                                                            <h4 id="modalTitle">
                                                                {{ aboutBlockedMobileOfferPopin.title }}
                                                            </h4>
                                                            <div class="row pt-2">
                                                                <div class="col-12">
                                                                    <p v-html="aboutBlockedMobileOfferPopin.line1" />
                                                                    <p v-html="aboutBlockedMobileOfferPopin.line2" />
                                                                    <p v-html="aboutBlockedMobileOfferPopin.line3" />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="modal-footer">
                                                            <button
                                                                type="button"
                                                                class="btn btn-secondary"
                                                                data-bs-dismiss="modal"
                                                            >
                                                                Fermer
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!--/* MOBILE TILE CLAIMS */-->
                                        <div v-if="mobileOffer.claims.length > 0" class="row pt-lg-1 px-1">
                                            <div
                                                v-for="claim in mobileOffer.claims"
                                                class="col-12 text-center"
                                                :class="claim.image ? mobileOffer.claimBgColor : 'bg-white'"
                                            >
                                                <div class="recap-claim">
                                                    <div class="p-1" :class="claim.image ? mobileOffer.claimBgColor : 'bg-white'">
                                                        <div v-if="claim.image">
                                                            <img
                                                                class="recap-claim-img"
                                                                loading="lazy"
                                                                :src="claim.image.url"
                                                                :alt="claim.image.alt"
                                                            >
                                                        </div>
                                                        <div v-for="attribute in claim.attributes">
                                                            <p class="mb-0 px-2 d-flex align-items-center justify-content-center">
                                                                <span v-html="attribute.textHtml" />
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <!--/* INTERNET TILE */-->
                                <section class="order-3 order-lg-2 col-12 col-lg-6 px-0 px-1 pb-1 pb-lg-0">
                                    <div class="container mw-100 h-100 border-gray recap-internet-tile px-0">
                                        <div class="row p-1">
                                            <div class="col-6">
                                                <p><strong>{{ internetOffer.name }}</strong></p>
                                            </div>
                                            <div class="col-6 text-end">
                                                <ob1-prix
                                                    :custom="'recap-ob1-price h3 text-dark'"
                                                    :duration="internetOffer.price.duration"
                                                    :initial-price="internetOffer.price.initialPrice"
                                                    :is-mini="true"
                                                    :price="internetOffer.price.price"
                                                    :price-details="internetOffer.price.priceDetails"
                                                    :show-by-month="internetOffer.price.showByMonth"
                                                    :show-end-of-promotion-price="internetOffer.price.showEndOfPromotionPrice"
                                                    :show-from="internetOffer.price.showFrom"
                                                    :show-promo-duration="internetOffer.price.showPromoDuration"
                                                />
                                            </div>
                                        </div>

                                        <!--/* CLAIMS */-->
                                        <div v-if="firstClaimWithImage" class="row pt-lg-1 px-1">
                                            <div class="col-12 text-center px-0" :class="offerClaimsClass">
                                                <div class="recap-claim">
                                                    <div class="p-1" :class="internetOffer.claimBgColor">
                                                        <div>
                                                            <img
                                                                class="recap-claim-img"
                                                                loading="lazy"
                                                                :src="firstClaimWithImage.image.url"
                                                                :alt="firstClaimWithImage.image.alt"
                                                            >
                                                        </div>
                                                        <div v-for="attribute in firstClaimWithImage.attributes">
                                                            <p class="mb-0 px-2 d-flex align-items-center justify-content-center">
                                                                <span v-html="attribute.textHtml" />
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <!--/* MOBILE DEVICE SELECTED */-->
                                <section
                                    v-if="cartRecapData.mobileDevice"
                                    class="order-2 order-lg-3 col-12 px-0 px-1 pb-1 pb-lg-0 pt-lg-1"
                                >
                                    <div class="container mw-100 border-gray recap-phone-tile px-0 h-100">
                                        <div class="row p-1">
                                            <div class="col-7">
                                                <div class="d-flex justify-content-start align-items-center">
                                                    <img
                                                        :src="cartRecapData.mobileDevice.picturePath"
                                                        :alt="cartRecapData.mobileDevice.pictureAlt"
                                                        loading="lazy"
                                                        class="device-picture-height pe-1"
                                                    >
                                                    <div>
                                                        <p class="mb-0 py-0">
                                                            <strong>{{
                                                                cartRecapData.mobileDevice.brand
                                                            }}</strong>
                                                        </p>
                                                        <p class="mb-0 py-0">
                                                            {{ cartRecapData.mobileDevice.name }}
                                                        </p>
                                                        <div class="d-flex align-items-center">
                                                            <div>
                                                                <span class="ob1-color-chips ob1-color-chips-mini">
                                                                    <span class="visually-hidden">Couleur du mobile</span>
                                                                    <span
                                                                        class="ob1-color-chip"
                                                                        :style="{backgroundColor: cartRecapData.mobileDevice.color.code}"
                                                                    >
                                                                        <span class="ob1-color-chips-mini-tooltip">{{
                                                                            cartRecapData.mobileDevice.color.colorName
                                                                        }}</span>
                                                                    </span>
                                                                </span>
                                                            </div>
                                                            <div class="ms-1">
                                                                {{ cartRecapData.mobileDevice.dataCapacity }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-5 device-price">
                                                <ob1-prix
                                                    :price="devicePrice"
                                                    :is-compact="true"
                                                    :custom="'text-dark'"
                                                    :class="'text-end'"
                                                    :is-cents-format="true"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <!--/* Tuile Total à droite en desktop */-->
                        <div class="col-12 col-lg-4 px-0 px-lg-1">
                            <!--/* TOTAL */-->
                            <div class="container mw-100 h-100 border-gray bg-dark recap-total-tile p-1">
                                <!--/* A payer tous les mois */-->
                                <div class="row">
                                    <div class="col-5 text-white">
                                        <p><strong>{{ cartRecapData.offersTotalPriceLabel }}</strong></p>
                                    </div>
                                    <div class="col-7 text-end">
                                        <ob1-prix
                                            :custom="'text-primary'"
                                            :duration="totalPrice.duration"
                                            :initial-price="totalPrice.initialPrice"
                                            :is-compact="totalPrice.compact"
                                            :is-inverse="totalPrice.inverse"
                                            :price="totalPrice.price"
                                            :price-details="totalPrice.priceDetails"
                                            :show-by-month="totalPrice.showByMonth"
                                            :show-end-of-promotion-price="totalPrice.showEndOfPromotionPrice"
                                            :show-from="totalPrice.showFrom"
                                            :show-promo-duration="totalPrice.showPromoDuration"
                                        />
                                    </div>
                                </div>

                                <!--/* PROMO REMISE OPEN SUR LE FORFAIT MOBILE */-->
                                <div class="row">
                                    <div
                                        v-if="mobileOffer.discountLabelWithMobileOfferMention"
                                        class="col-12"
                                    >
                                        <div class="my-1">
                                            <hr class="separator separator--gray4">
                                            <div class="my-1 d-flex align-items-center justify-content-center">
                                                <span
                                                    class="alert-icon px-1 icon-phone-fund-euro text-primary font-size-28 me-1"
                                                    aria-hidden="true"
                                                />
                                                <span class="ob1-alert-title fw-bold text-white">{{
                                                    formattedMobileDiscountLabel
                                                }}</span>
                                            </div>
                                            <hr class="separator separator--gray4">
                                        </div>
                                    </div>
                                </div>

                                <!--/* Prix du téléphone mobile */-->
                                <div v-if="cartRecapData.mobileDevice" class="row">
                                    <div class="col-5 text-white">
                                        <p><strong> {{ cartRecapData.devicePriceLabel }}</strong></p>
                                    </div>
                                    <div class="col-7 text-end">
                                        <ob1-prix
                                            :price="devicePrice"
                                            :is-compact="true"
                                            :is-inverse="true"
                                            :additional-mention-bold="cartRecapData.devicePriceOnOrderLabel"
                                            :class="'text-end'"
                                            :is-cents-format="true"
                                        />
                                    </div>
                                </div>

                                <!--/* CTA */-->
                                <div class="col-12 pt-1 text-center">
                                    <generic-button-cta
                                        :dto-from-object="selectOfferRecapCta"
                                        css-classes="btn-primary btn-inverse"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import {alignDivHeights} from "../../../../utils/AlignDivHeightsUtil";
import GenericButtonCta from "../../../../../../common/broadband/components/GenericButtonCta.vue";
import EligibilityResult from "../../internetandmobileoffers/components/eligibility/EligibilityResult.vue";

export default {
    name: "CartRecap",
    components: {
        GenericButtonCta,
        EligibilityResult
    },
    props: {
        mobileOffersModel: {type: Array, required: true},
        cartRecapData: {type: Object, required: true},
        selectedInternetOfferSeoId: {type: String, required: true},
        selectedMobileOfferSeoId: {type: String, required: true},
        internetOffersTiles: {type: Array, required: true},
        mobileOffersTiles: {type: Array, required: true},
        newPackSummariesBySeoIds: {type: Object, required: true},
        blockedMobileOfferTitle: {type: String, required: true},
        blockedMobileOfferToggleTms: {type: Object, required: true},
        blockedMobileOfferPopinTms: {type: Object, required: true},
        aboutBlockedMobileOfferPopin: {type: Object, required: true},
        showEligibilityResult: {type: Boolean, required: false, default: true},
        position: {type: String, required: true},
    },
    computed: {
        mobileOffer() {
            return this.mobileOffersTiles.find(offer => offer.seoId === this.selectedMobileOfferSeoId)
        },
        internetOffer() {
            return this.internetOffersTiles.find(offer => offer.seoId === this.selectedInternetOfferSeoId)
        },
        devicePrice() {
            return this.mobileOffer.devicePrice
        },
        formattedMobileDiscountLabel() {
            if (this.mobileOffer.discountLabelWithMobileOfferMention) {
                return this.handleBreakingSpaces(this.mobileOffer.discountLabelWithMobileOfferMention)
            } else {
                return undefined
            }
        },
        privateFormParams() {
            let result = this.cartRecapData?.mobileDevice?.seoId ? {"deviceMobileIdSeo": this.cartRecapData.mobileDevice.seoId} : {};
            return result;
        },
        totalPrice() {
            return this.newPackSummariesBySeoIds[this.selectedInternetOfferSeoId][this.selectedMobileOfferSeoId].totalPrice
        },
        selectOfferRecapCta() {
            if (this.cartRecapData.eligibilityResult !== undefined) {
                return this.newPackSummariesBySeoIds[this.selectedInternetOfferSeoId][this.selectedMobileOfferSeoId].genericButtonCta
            } else {
                let simpleButtonCta = this.newPackSummariesBySeoIds[this.selectedInternetOfferSeoId][this.selectedMobileOfferSeoId].genericButtonCta
                if (simpleButtonCta.actionFormParams !== undefined) {
                    simpleButtonCta.actionFormParams.position = this.position
                }
                return simpleButtonCta
            }
        },
        offerHasVariation() {
            return this.mobileOffersModel.find(model => model.seoId === this.selectedMobileOfferSeoId).variationOfferSeoId !== undefined
        },
        offerVariationOfferSeoId() {
            return this.mobileOffersModel.find(model => model.seoId === this.selectedMobileOfferSeoId).variationOfferSeoId
        },
        firstClaimWithImage() {
            return this.internetOffer.claims.find(claim => claim.image) || null;
        },
        offerClaimsClass() {
            let returnedBgClass = 'bg-white';
            if ( this.internetOffer && this.internetOffer.claimBgColor && this.firstClaimWithImage ) {
                returnedBgClass = this.internetOffer.claimBgColor
            }
            return returnedBgClass;
        }
    },
    updated() {
        const listOfDivToAlign = ["recap-claim", "recap-ob1-price"];
        alignDivHeights(listOfDivToAlign);
    },
    methods: {
        handleBreakingSpaces(str) {
            return str.replace('&nbsp;', '\xa0');
        },
        onMobileOfferToggleChange() {
            this.$emit('select-mobile-offer-seo-id', this.offerVariationOfferSeoId);
        }
    }
}
</script>

<style scoped lang="scss">
@import 'ob1_variables', 'ob1_common';

.border-gray {
    border: px-to-rem(2) solid $gray-lighter;
}

.device-picture-height {
    height: 100px;
}

.device-price {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.recap-mobile-tile {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.recap-internet-tile {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.recap-claim-img {
    height: 40px;
    max-width: 80%;
}
</style>
